import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaypointResponse } from 'src/app/core/bridge-pay/models/paypoint-response.interface';

@Component({
  selector: 'kt-bridgepay-paypoint-item',
  templateUrl: './paypoint-item.component.html',
  styleUrls: ['./paypoint-item.component.scss'],
})
export class PaypointItemComponent {
  @Input() paypoint: PaypointResponse;
  @Output() test = new EventEmitter<string>();
  @Output() edit = new EventEmitter<string>();
  @Output() delete = new EventEmitter<string>();
}
